import { Popover } from 'antd'
import Badge from '@mui/material/Badge'
import { NotificationOutlined } from '@ant-design/icons'
import { InfiniteList } from '@features/notifications/list'
import './style.css'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { notificationsSelectors } from '@/entity/notifications/index'

export const NotifyBadge = () => {
	const notifyData = useSelector(notificationsSelectors.notifications)
	const [unreadCount, setUnreadCount] = useState(0)
	const [isOpen, setIsOpen] = useState(false)

	useEffect(() => {
		setUnreadCount(notifyData?.badgeLength)
	}, [notifyData])

	const onVisibleChange = (e) => {
		setIsOpen(e)
	}

	const handleCloseNotifyPopover = () => {
		setIsOpen(false)
	}

	const content = (
		<InfiniteList
			id="infinitelist"
			content={notifyData?.badgeContent}
			onClose={handleCloseNotifyPopover}
		/>
	)

	return (
		<Popover
			placement="bottomRight"
			overlayClassName="wrapper-notify"
			content={content}
			open={isOpen}
			trigger="click"
			onOpenChange={onVisibleChange}
		>
			<Badge
				badgeContent={unreadCount}
				sx={{
					'& .MuiBadge-badge': {
						color: 'white',
						backgroundColor: '#17b67c',
					},
				}}
			>
				<NotificationOutlined style={{ fontSize: '16px' }} />
			</Badge>
		</Popover>
	)
}
